export class PathUtility {
    static getUriPath(): string {
        let base = document.getElementsByTagName('base');
        if (base.length > 0) {
            let baseURI = base[0].baseURI;
            let pathname = window.location.href.replace(baseURI, '');
            let parametersIndex = pathname.indexOf('?');
            if (parametersIndex > -1) {
                pathname = pathname.substring(0, parametersIndex);
            }
            return pathname;
        }
        return window.location.pathname;
    }
}